import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Card, CardBody} from 'reactstrap';
import withAuth from '../../../../components/Services/WithAuth';
import TableView from './TableView/index';
import { overriddingRiskFactorList } from './action';
import './style.css';
class OverridingRiskFactorList extends Component {
    constructor() {
        super();
        this.state = {
            overriddingRiskFactorData: []
        };
    }
    componentDidMount() {
        this.props.overriddingRiskFactorList();
    }
    componentDidUpdate(prevProps) {
        if (this.props.overRiddingRiskFactorListData !== prevProps.overRiddingRiskFactorListData) {
            this.setState({
                overriddingRiskFactorData: this.props.overRiddingRiskFactorListData.data
            })
        }
    }
    handleCancel = () => {
        this.props.history.push('../search')
    }
    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">List of Overridding Risk Factors</h4>
                </div>
                <Card>
                    <CardBody>
                        <TableView {...this.props} data={this.state.overriddingRiskFactorData} />
                    </CardBody>
                </Card>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    overRiddingRiskFactorListData: state.overriddingRiskFactor.overriddingRiskList
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    overriddingRiskFactorList: () => { dispatch(overriddingRiskFactorList()) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(OverridingRiskFactorList));
